import { io } from "socket.io-client";

const API_URL = process.env.REACT_APP_HUB_API_URL || "http://localhost:4100";

let socket = null;

export function connectSocket(tenantId) {
  if (socket?.connected) return socket;

  socket = io(API_URL, {
    query: { tenantId },
    transports: ["websocket", "polling"],
  });

  socket.on("connect", () => {
    console.log("[Hub:Socket] Connected:", socket.id);
  });

  socket.on("disconnect", () => {
    console.log("[Hub:Socket] Disconnected");
  });

  return socket;
}

export function getSocket() {
  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
